import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = null;

export const zohoIntegrationIdSlice = createSlice({
  name: 'zohoIntegrationId',
  initialState,
  reducers: {
    setIntegrationId: (state, { payload: { integrationId } }) => {
      return integrationId;
    },
    resetIntegrationId: () => {
      return null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIntegrationId, resetIntegrationId } =
  zohoIntegrationIdSlice.actions;

export const getZohoIntegrationIdState = (state: RootState) =>
  state.zohoIntegrationId;

export default zohoIntegrationIdSlice.reducer;
